import { message } from 'antd';
import { useMutation, useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';

import { PublicApplicationCommandAPI } from '@lib/api/endpoints/Applications/command';
import { RootState } from '@lib/redux.lib/store';
import { logIfDevelopment } from '@lib/utils/logging';

import { JobsBoardSearchFiltersPayload } from '../utils';

export const useUpsertJobsBoardDefaultFilters = (
  jobsBoardDefaultFilters: JobsBoardSearchFiltersPayload
) => {
  const loggedInUserId = useSelector(
    (state: RootState) => state.app?.user?.profile?.id
  );

  const queryClient = useQueryClient();

  const {
    mutateAsync: upsertJobsBoardDefaultFilters,
    isLoading: isUpsertingJobsBoardDefaultFilters,
  } = useMutation({
    mutationFn: async () => {
      if (!loggedInUserId) {
        throw new Error('User not logged in');
      }
      const result =
        await PublicApplicationCommandAPI.upsertJobsBoardDefaultFilters(
          jobsBoardDefaultFilters,
          loggedInUserId
        );

      await queryClient.invalidateQueries([
        'jobsBoardDefaultFilters',
        loggedInUserId,
      ]);

      message.success('Jobs board default filters updated');

      return result;
    },
    onError: (error) => {
      logIfDevelopment(error);
      message.error('Failed to update jobs board default filters');
    },
  });

  return {
    upsertJobsBoardDefaultFilters,
    isUpsertingJobsBoardDefaultFilters,
  };
};
